import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { routesData } from "../../common";

const LayoutBox = () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                {
                    routesData?.map((route, index) => {
                        return <Route key={index} path={route?.path} element={route?.element} />
                    })
                }
            </Routes>
        </Suspense>
    )
}

export default LayoutBox;
